<div style="padding:20px;">
    <div *ngIf="opmPartners && opmPartners.length > 0">
        <nb-form-field>
          <nb-select [(ngModel)]="partnerId" placeholder="Partner" (selectedChange)="getNewView()">
            <nb-option [value]="null">None</nb-option>
            <nb-option *ngFor="let partner of opmPartners" [value]="partner.id">{{partner.name}}</nb-option>
          </nb-select>
        </nb-form-field>
    </div>
    <app-view [items]="view?.data?.content" [data]="data?.data" *ngIf="view && view?.data" [info]="info" ></app-view>
</div>
<div style="text-align:center;">
<!--    <button nbButton status="primary" [disabled]="checkErrors()" (click)="create()">Create</button>-->
</div>

